import React, { Component } from 'react';
import {Table, Header, Form, Button} from 'semantic-ui-react';
import * as Events from '../../store/Events';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const dataTypeOptions = [
    {value: 'text', text: 'Text Input'},
    // {value: 'date', text: 'Date Selection'}
];
class EventCustomFields extends Component {
    constructor(props) {
        super(props);
        const {event} = props;
        const additionalFields = event && event.additionalFields ? JSON.parse(event.additionalFields) : {};
        this.state = {
            name: '',
            dataType: 'text',
            label: '',
            additionalFields
        }
        this.onChange = this.onChange.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    onChange(e, {name, value}) {
        if (name === 'name') {
            var fixed = value.replace(/[^a-z0-9]/gi,'');
            this.setState({[name]: fixed});
        } else {
            this.setState({[name]: value});
        }
    }

    async onAdd(e) {
        const {event, actions} = this.props;
        const {name, label, dataType, additionalFields} = this.state;

        const newFields = {...additionalFields, [name]: {name, label, dataType}};

        this.setState({additionalFields: newFields});

        try {
            await actions.updateEvent({...event, additionalFields: JSON.stringify(newFields)});
            // actions.replace(`/admin/event/${result.response.id}/inventory`);
        } catch (error) {
            this.setState({error: error.message});
        }
    }

    async onDelete(e, {name}) {
        const {event, actions} = this.props;
        const {additionalFields} = this.state;

        delete additionalFields[name];

        this.setState({additionalFields});

        try {
            await actions.updateEvent({...event, additionalFields: JSON.stringify(additionalFields)});
            // actions.replace(`/admin/event/${result.response.id}/inventory`);
        } catch (error) {
            this.setState({error: error.message});
        }
    }
    
    render() {
        const {event} = this.props;
        const {additionalFields, name, label, dataType} = this.state;
        console.log(additionalFields);
        return (
            <div>
                <Header as='h1' content="Edit Custom Fields" />
                <Form>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={4}>Custom Fields - {event.name}</Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell>Field Name</Table.HeaderCell>
                            <Table.HeaderCell>Field Label</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Data Type</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell width={5}><Form.Input name="name" value={name} placeholder="Field Name" onChange={this.onChange} /></Table.Cell>
                            <Table.Cell width={5}><Form.Input name="label" value={label} placeholder="Field Label" onChange={this.onChange} /></Table.Cell>
                            <Table.Cell width={5}>
                                <Form.Dropdown name="dataType" selection options={dataTypeOptions} defaultValue="text" onChange={this.onChange} value={dataType} />
                            </Table.Cell>
                            <Table.Cell>
                            <Button content="Add" onClick={this.onAdd} />

                            </Table.Cell>
                        </Table.Row>
                        {Object.keys(additionalFields).map(f => (
                            <Table.Row>
                                <Table.Cell width={5}>
                                    {additionalFields[f].name}
                                </Table.Cell>
                                <Table.Cell width={5}>
                                    {additionalFields[f].label}
                                </Table.Cell>
                                <Table.Cell width={5}>
                                    {additionalFields[f].dataType}
                                </Table.Cell>
                                <Table.Cell><Button name={f} icon="delete" onClick={this.onDelete}  /></Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
                </Form>
                
            </div>
        );
    }
}

EventCustomFields.propTypes = {

};

const mapStateToProps = (state, ownProps) => {
    return {
        event: Events.selector(state).events[ownProps.match.params.eventId],
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Events.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventCustomFields));